import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconQaOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12.5991C12 13.2258 11.8935 13.7711 11.6806 14.235C11.4677 14.6959 11.1725 15.066 10.7951 15.3456L11.9661 16.2212L11.0419 17L9.54191 15.8526C9.37097 15.8802 9.19351 15.894 9.00969 15.894C8.4258 15.894 7.90483 15.7604 7.44677 15.4931C6.98871 15.2258 6.63387 14.8449 6.38226 14.3503C6.13064 13.8525 6.00323 13.2811 6 12.6359V12.3041C6 11.6436 6.12419 11.063 6.37258 10.5622C6.62419 10.0583 6.97742 9.67278 7.43226 9.40549C7.89032 9.13516 8.41292 9 8.99999 9C9.58707 9 10.108 9.13516 10.5629 9.40549C11.0209 9.67278 11.3742 10.0583 11.6226 10.5622C11.8741 11.063 12 11.6421 12 12.2995V12.5991ZM10.5291 12.295C10.5291 11.5914 10.3968 11.0568 10.1322 10.6912C9.86773 10.3256 9.49031 10.1429 8.99999 10.1429C8.51286 10.1429 8.13707 10.3241 7.87256 10.6866C7.60806 11.0461 7.47419 11.5745 7.47096 12.2719V12.5991C7.47096 13.2842 7.60322 13.8157 7.86774 14.1936C8.13226 14.5714 8.51286 14.7604 9.00969 14.7604C9.49675 14.7604 9.87098 14.5791 10.1322 14.2166C10.3935 13.851 10.5258 13.3195 10.5291 12.6221V12.295Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8461 13.7637H14.1487L13.6359 15H12L14.7794 9H16.2051L19 15H17.3641L16.8461 13.7637ZM14.5641 12.7624H16.4308L15.4923 10.5165L14.5641 12.7624Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconQaOutline;
